import Glide from "@glidejs/glide";
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["slider"];

  connect() {
    this.createGlide();
    window.addEventListener("resize", this.resizeHandler.bind(this));
  }

  resizeHandler() {
    this.glide.destroy();
    this.createGlide();
  }

  createGlide() {
    const sliders = this.sliderTarget.querySelectorAll(".glide__slide");
    if (sliders.length === 0) {
      return;
    }
    if (window.innerWidth >= 700) {
      this.glide = new Glide(this.sliderTarget, {
        type: "carousel",
        startAt: 0,
        perView: 2,
        peek: { before: 0, after: 202 },
        gap: 24,
        swipeThreshold: 5,
        dragThreshold: 5
      }).mount();
    } else {
      this.glide = new Glide(this.sliderTarget, {
        type: "carousel",
        startAt: 0,
        perView: 1,
        peek: { before: 0, after: 71 },
        gap: 24,
        swipeThreshold: 5,
        dragThreshold: 5
      }).mount();
    }
  }

  handleClickNextSlide(event) {
    event.preventDefault();
    this.glide.go("<");
  }

  handleClickPrevSlide(event) {
    event.preventDefault();
    this.glide.go(">");
  }

  disconnect() {
    this.glide.destroy();
    window.removeEventListener("resize", this.resizeHandler);
  }
}
